import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./shared";
import { FAQS } from "../../lib/data";

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="section" id="faq" data-testid="faq-section">
      <div className="container">
        <Reveal><p className="eyebrow center">FAQ</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="section-title" style={{ marginTop: 16, textAlign: "center" }}>
            Common <span className="accent">questions</span>
          </h2>
        </Reveal>

        <div style={{ maxWidth: 820, margin: "48px auto 0" }}>
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 0.05}>
                <div style={{ borderBottom: "1px solid rgba(17,17,17,0.1)", padding: "6px 0" }}>
                  <button data-testid={`faq-question-${i}`} onClick={() => setOpen(isOpen ? -1 : i)}
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%",
                      textAlign: "left", gap: 20, padding: "20px 0", fontWeight: 700, fontSize: 16.5, color: "var(--black)" }}>
                    {f.q}
                    <motion.span animate={{ rotate: isOpen ? 135 : 0, backgroundColor: isOpen ? "#C1121F" : "rgba(0,0,0,0)" }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      style={{ width: 28, height: 28, borderRadius: "50%", border: "1.5px solid var(--red)",
                        display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
                      <Plus size={15} color={isOpen ? "#fff" : "var(--red)"} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div key="a" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        style={{ overflow: "hidden" }} data-testid={`faq-answer-${i}`}>
                        <p style={{ color: "var(--muted)", fontSize: 14.5, paddingBottom: 20 }}>{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
